// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"3f1f065c","489":"e490bdff","658":"4b79ad81","683":"17c65153"}[chunkId] + ".chunk.js";
};